import { render, staticRenderFns } from "./TrainingCourseEdit.vue?vue&type=template&id=678d96f4&"
import script from "./TrainingCourseEdit.vue?vue&type=script&lang=js&"
export * from "./TrainingCourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports